import { Badge, Banner, BlockStack, InlineStack, Text } from "@shopify/polaris";
import { shopifyFecth, t } from "../../query/share";
import { params, getPlans } from "../../query/env";
import { useEffect, useState } from "react";
import { modalsType } from "../hooks/modals";
import { baseType } from "../hooks/base";

const PlanSingle = (props: { planName: string } & modalsType & baseType) => {
  const { planName, base, changeBase } = props;
  const [url, setUrl] = useState("");
  const plans = getPlans();
  const plan = plans[planName];

  useEffect(() => {
    if (!base.payment?.[plan.name]) {
      getSubuscriptionUrl();
    } else {
      setUrl(base.payment[plan.name]);
    }
  }, []);

  const getSubuscriptionUrl = async () => {
    console.log("getSubuscriptionUrl");
    //@ts-ignore
    const shop = shopify.config.shop;
    const returnUrl = `https://admin.shopify.com/store/${shop.replace(
      ".myshopify.com",
      "",
    )}/apps/${params.handle}`; //?host=${bufferHost}`;
    const result = await shopifyFecth({
      query: `
    mutation {
        appSubscriptionCreate(
            name: "${plan.name}"
            returnUrl: "${encodeURI(returnUrl)}"
            trialDays: 14
            test: ${false}
            lineItems: [
            {
              plan: {
                appRecurringPricingDetails: {
                    price: { amount: ${plan.price}, currencyCode: USD }
                    interval: EVERY_30_DAYS
                }
              }
            }
            ]
          ) {
              userErrors {
                field
                message
              }
              confirmationUrl
              appSubscription {
                id
              }
          }
        }
    `,
    });

    if (
      !result.appSubscriptionCreate?.appSubscription ||
      result.appSubscriptionCreate.userErrors.length
    )
      return;

    changeBase({
      payment: { [plan.name]: result.appSubscriptionCreate.confirmationUrl },
    });
    setUrl(result.appSubscriptionCreate.confirmationUrl);
  };

  return (
    <BlockStack gap="200">
      <InlineStack gap="200">
        <Text as="h3" variant="headingMd">
          {plan.name}
        </Text>
        <Badge tone={plan.tone}>{`${plan.price.toString()}${t(
          "ドル",
          "$",
        )}`}</Badge>
      </InlineStack>
      <p>
        {t(
          "使用を始める前に定期料金の承認をお願いします。7日間の無料体験があります。アンイストールすることでいつでも解除可能です。",
          "Please approve the subscription fee before you start using the service. There is a 7-day free trial period. You can cancel at any time by uninstalling the app.",
        )}
      </p>

      <Banner
        action={{
          content: t("支払い画面へ", "Go to payments"),
          loading: !url,
          url: url,
          target: "_top",
        }}
      >
        <Text as="p">
          {t(
            "料金の承認画面に遷移します",
            "Transitioning to the approval screen for fees.",
          )}
        </Text>
      </Banner>
    </BlockStack>
  );
};

export default PlanSingle;
